import { ColumnProps } from 'antd/lib/table';
import moment from 'moment-timezone';
import React from 'react';
import Icon from '~/components/Icon';
import Button from '~/components/ui/Button';
import TableCell from '~/components/ui/Table/TableCell';
import ScenarioModel from '~/models/ScenarioModel';
import hintsForTheTable from '~/screens/ScenariosScreen/HintsForTheTable';

interface IScenarioListColumns {
  setErrorMessageVisible: () => void;
  setErrorWhenCheckScriptException: () => void;
  filterStatsByScenarioId: (id: number) => any;
  getScenariosCount: () => void;
}

export const getScenarioListColumns = ({
  setErrorMessageVisible,
  setErrorWhenCheckScriptException,
  filterStatsByScenarioId,
  getScenariosCount,
}: IScenarioListColumns): ColumnProps<ScenarioModel>[] => {
  return [
    {
      className: 'scenarios-screen-list-table__status',
      key: 'status',
      title: 'Статус',
      render: (_, scenario) => {
        let icon: React.ReactNode;
        let title: string;
        let hoverContent: React.ReactNode;

        console.log('isActive', scenario.isActive);

        if (scenario.isActive) {
          title = 'Запущен';
          icon = <Icon name="PlayS" style={{ color: '#00BF6D' }} />;
          hoverContent = (
            <Button
              icon="PauseS"
              type="black-outline"
              loading={scenario.isPausing}
              disabled={scenario.isPausing}
              onClick={(e) => {
                e.stopPropagation();

                scenario.pause().then(() => {
                  if (scenario.errorWhenChangingStatus) {
                    setErrorMessageVisible();
                  }
                });
              }}
            >
              Остановить
            </Button>
          );
        }

        if (scenario.isPaused) {
          title = 'Остановлен';
          icon = <Icon name="PauseS" style={{ color: '#808080' }} />;
          hoverContent = (
            <Button
              icon="PlayS"
              type="black-outline"
              loading={scenario.isActivating}
              disabled={scenario.isActivating}
              onClick={(e) => {
                e.stopPropagation();

                scenario.activate().then(() => {
                  if (scenario.errorWhenChangingStatus) {
                    setErrorMessageVisible();
                  }
                  if (scenario.errorWhenCheckScriptException) {
                    setErrorWhenCheckScriptException();
                  }
                });
              }}
            >
              Запустить
            </Button>
          );
        }

        return (
          <TableCell icon={icon} title={title} hoverContent={hoverContent} />
        );
      },
    },
    {
      key: 'name',
      title: 'Название сценария',
      render: (_, scenario) => {
        return (
          <TableCell
            title={scenario.get('name')}
            subtitle={scenario.get('description')}
          />
        );
      },
    },
    {
      key: 'type',
      title: 'Устройства показа',
      render: (_, scenario) => {
        let title: JSX.Element = (
          <div className="scenarios-screen-scenarios-list-colum-type__wrapper">
            <Icon
              name="DeviceDesktop"
              className={'scenarios-screen-scenarios-list-colum-type__icon'}
            />
            <div className="scenarios-screen-scenarios-list-colum-type__label">
              Компьютеры
              <br />и планшеты
            </div>
          </div>
        );
        const isMobile = scenario.get('isMobile');
        if (isMobile) {
          title = (
            <div className="scenarios-screen-scenarios-list-colum-type__wrapper">
              <Icon
                name="DevicePhone"
                className={'scenarios-screen-scenarios-list-colum-type__icon'}
              />
              <div className="scenarios-screen-scenarios-list-colum-type__label">
                Мобильные
                <br />
                устройства
              </div>
            </div>
          );
        }

        return (
          <TableCell
            title={isMobile === null || isMobile === undefined ? '' : title}
          />
        );
      },
    },
    {
      key: 'date',
      title: 'Дата создания',
      render: (_, scenario) => {
        if (!scenario.get('created_date')) return null;

        const date = moment(scenario.get('created_date'), 'x');

        return <TableCell title={date.format('DD.MM.YYYY')} />;
      },
    },
    {
      key: 'shown',
      title: hintsForTheTable('Показы'),
      render: (_, scenario) => {
        const statsElement = filterStatsByScenarioId(scenario.get('id'));

        return (
          <TableCell
            title={`${statsElement.widgetShowPercent}%`}
            subtitle={`${statsElement.widgetShowCount}/${statsElement.visitsTotalCount}`}
          />
        );
      },
    },
    {
      key: 'interactions',
      title: hintsForTheTable('Взаимодействия'),
      render: (_, scenario) => {
        const statsElement = filterStatsByScenarioId(scenario.get('id'));

        return (
          <TableCell
            title={`${statsElement.widgetIteractionPercent}%`}
            subtitle={`${statsElement.widgetIteractionCount}/${statsElement.widgetShowCount}`}
          />
        );
      },
    },
    {
      className: 'scenarios-screen-list-table__action',
      key: 'action',
      title: '',
      render: (_, scenario) => {
        return (
          <Button
            tag="a"
            type="text"
            loading={scenario.isRemoving}
            onClick={async (e) => {
              e.stopPropagation();
              await scenario.remove();
              await getScenariosCount();
            }}
          >
            Удалить
          </Button>
        );
      },
    },
  ];
};
